module.exports = __webpack_public_path__ + "static/media/indentplanner_2.efba5217.png";